// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPlan {
    static getAttributeTypeMap() {
        return MedicalEligibilityPlan.attributeTypeMap;
    }
}
MedicalEligibilityPlan.discriminator = undefined;
MedicalEligibilityPlan.additionalProperties = false;
MedicalEligibilityPlan.attributeTypeMap = [
    {
        "name": "isAccumulator",
        "baseName": "isAccumulator",
        "type": "string"
    },
    {
        "name": "isMaximizer",
        "baseName": "isMaximizer",
        "type": "string"
    },
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "priority",
        "baseName": "priority",
        "type": "string"
    },
    {
        "name": "terminationDate",
        "baseName": "terminationDate",
        "type": "string"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPlan.js.map